module.exports = {"id":"177390","name":"Haris Medunjanin","rating":"76","photo":"./data/images/photos/2/177390.png","club":{"name":"Philadelphia U.","logo":"./data/images/clubs/PhiladelphiaU..png"},"positions":["MC","MDC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HarisMedunjanin0.json
// module id = 1695
// module chunks = 0